import { useState, useCallback, useRef } from 'react';

export default function useForceRender(): () => void {
	const [value, set] = useState(true);
	const valueRef = useRef(value);
	valueRef.current = value;
	return useCallback(() => set(!valueRef.current), []);
}
